import {InputBaseComponentProps, TextField as MuiTextField, TextFieldProps,} from '@mui/material';
import {makeStyles} from '@mui/styles';

import withStyles from '@mui/styles/withStyles';
import {useCallback} from 'react';
import {NumberFormatProps} from 'react-number-format';
import {TEntity} from '../../../../models/entity';
import {markRequiredLabelRed, showRequiredMark} from '../../../utils/formUtils';
import {useEditPanelContext} from '../../components/AdminDataGrid/EditPanelContext';
import {NumericInput} from './NumberFormat';
import clsx from 'clsx';

export type CustomTextFieldProps = Omit<TextFieldProps, 'variant' | 'error' | 'type'> & (NumericProps | NonNumericProps) & {
  error?: string;
  readOnly?: boolean;
  disableValidation?: boolean;
};

type NumericProps = Omit<TextFieldProps, 'type' | 'inputProps'> & {
  inputProps?: NumberFormatProps;
  type: 'number';
};

type NonNumericProps = {
  type?: React.HTMLInputTypeAttribute;
  inputProps?: InputBaseComponentProps;
  isNumeric?: false;
};

export const redRequiredLabel = makeStyles(() =>({
  requiredLabelStyle: {
    '& .Mui-required': {
      color: 'red !important'
    }
  }
}));

const WithStylesTextField = withStyles({
  root: {
    ' & input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button':
      {
        display: 'none',
      },
    '&.MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
    '&input[type=number]': {
      '-moz-appearance':'textfield'
    }
  },
})(MuiTextField);

export default function TextField({
  error,
  multiline,
  required,
  disabled,
  autoComplete = 'off',
  size,
  name,
  inputProps,
  fullWidth = true,
  disableValidation,
  InputProps,
  type,
  readOnly,
  ...other
}: CustomTextFieldProps) {
  let customInputProps = {...InputProps, readOnly};
  if(type === 'number') customInputProps = {...customInputProps, inputComponent: NumericInput as any};

  const {validateField, mode} = useEditPanelContext<TEntity>(); 
  const  handleLoseFocus = useCallback((e : React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) =>
  {
    if(!validateField || !required || !name || (e.target.value?.length !== 0))
      return;
      validateField(e.target.value, name);
  },[validateField, name, required]);
 const {requiredLabelStyle} = redRequiredLabel();
  return (
      <WithStylesTextField
        {...other}
        fullWidth={fullWidth}
        className ={clsx(other.className, markRequiredLabelRed(other.value,mode) ? requiredLabelStyle : '')}
        type={type === 'number' ? 'string' : type}
        InputProps={customInputProps}
        name={name}
        autoComplete={autoComplete}
        inputProps={{ ...inputProps, maxLength:  inputProps?.allowNegative && inputProps?.maxLength ? inputProps.maxLength + 1 : inputProps?.maxLength }}
        error={!!error}
        onBlur={(e) => {
          other.onBlur?.(e);
          handleLoseFocus(e);
        }}
        size={size}
        InputLabelProps={{
          shrink: true,
        }}       
        disabled={disabled && !disableValidation}
        required={!disableValidation && showRequiredMark(other.value,mode,error,required)}
        multiline={multiline}
        onKeyUp={(event) => {
          if (event.key === 'Enter' && multiline) {
            event.preventDefault();
          }
        }}
      />
  );
}

